import { PersonModel, ScheduleModalPeople } from '@/types';

export const person: PersonModel = {
  name: 'Przemysław',
  surname: 'Draga',
  position: 'Chief Strategy Officer',
  linkedinLink: 'https://pl.linkedin.com/in/przemys%C5%82aw-draga-aa3572195',
  modal: ScheduleModalPeople.przemyslawD
};
